import React, {Component} from 'react'
import {JOB_STATUS} from "../../helper/jobFilter"
import PropTypes from 'prop-types'
import SelectFilterOptions from "../../../shared/SelectFilterOptions"

class FilterStatus extends Component {
    _handleChangeSelect = (field, value) => {
        const {onChangeSelect} = this.props

        if (typeof onChangeSelect === 'function') {
            onChangeSelect(field, value)
        }
    }

    render() {
        const {status} = this.props

        return (
            <div className="FilterStatus col-12 col-xl-auto mb-3">
                <SelectFilterOptions
                    defaultValue={status}
                    handleChange={this._handleChangeSelect}
                    listOptions={JOB_STATUS}
                    field="status" label="Trạng thái"
                />
            </div>
        )
    }
}

FilterStatus.propTypes = {
    status: PropTypes.string,
    onChangeSelect: PropTypes.func.isRequired
}

export default FilterStatus